



























































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Gasequipment from "../../../store/entities/gasequipment";
@Component
export default class CreatGasequipments extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  gasequipment: Gasequipment = new Gasequipment();
  idisable: boolean = false;
  selwarehouselist = [];
  selfloorlist = [];
  created() {}
  gflist = [];
  displaynone = "";
  seltypelist = [];
  seltime = [
    { value: 1, label: "1分钟" },
    { value: 5, label: "5分钟" },
    { value: 10, label: "10分钟" },
    { value: 15, label: "15分钟" },
    { value: 30, label: "30分钟" },
    { value: 60, label: "60分钟" },
    { value: 120, label: "120分钟" },
    { value: 240, label: "240分钟" },
    { value: 360, label: "360分钟" },
    { value: 720, label: "720分钟" },
    { value: 1440, label: "1440分钟" },
  ];
  Isoxygen = false;
  Iscarbondioxide = false;
  Isnitrogen = false;
  Ischlorinehydride = false;
  Iscarbonicoxide = false;
  updateInterval = false;
  // gastype = [
  //   { value: 1, label: "氧气" },
  //   { value: 2, label: "二氧化碳" },
  //   { value: 3, label: "氮气" },
  //   { value: 4, label: "磷化氢" },
  // ];
  visibleChange(value: boolean) {
    this.selgId();
    if (!value) {
      this.$emit("input", value);
    }
  }
  get smokecrib() {
    return this.$store.state.smokecrib.filterlist;
  }
  get gasthreshold() {
    return this.$store.state.gasthreshold.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  get gwequipment() {
    return this.$store.state.gwequipment.list;
  }

  selfactory(value: Number) {
    this.gasequipment.ftId = value;
    if (value != 0 && value != undefined) {
      this.getselwarehouse();
    }
  }
  selwarehouse(value: Number) {
    this.gasequipment.wId = value;
    if (value != 0 && value != undefined) {
      this.getselfloor();
    } else {
      this.gasequipment.fId = 0;
      this.selfloorlist = [];
    }
    // this.getfloor();
  }
  selfloor(value: Number) {
    this.gasequipment.fId = value;
  }
  selEth() {
    this.displaynone = "display:none";
  }
  selth() {
    this.displaynone = "";
  }
  selgId() {
    var gwelist = this.$store.state.gwequipment.list;
    var faclist = this.$store.state.factory.list;
    var wlist = this.$store.state.warehouse.list;
    var flist = this.$store.state.floor.list;
    var globallist = [];
    for (var i = 0; i < gwelist.length; i++) {
      var gweId = gwelist[i].ftId;
      for (var j = 0; j < faclist.length; j++) {
        var facId = faclist[j].id;
        if (gweId == facId) {
          globallist[i] = faclist[j].fName;
        }
      }
      for (var w = 0; w < wlist.length; w++) {
        if (gwelist[i].wId == wlist[w].id) {
          globallist[i] = globallist[i] + wlist[w].wName;
        }
      }
      for (var f = 0; f < flist.length; f++) {
        if (gwelist[i].fId == flist[f].id) {
          globallist[i] = globallist[i] + flist[f].fName;
        }
      }
      if (gwelist[i].frequency == null) {
        this.gflist[i] = { value: gwelist[i].id, label: globallist[i] };
      } else {
        this.gflist[i] = {
          value: gwelist[i].id,
          label: globallist[i] + gwelist[i].frequency,
        };
      }
    }
  }
  async getselwarehouse() {
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.gasequipment,
    });
  }
  async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.gasequipment,
    });
  }
  save() {
    (this.$refs.gasequipmentForm as any).validate(async (valid: boolean) => {
      this.displaynone = "";
      if (valid) {
        this.idisable = true;
        if (this.updateInterval == true) {
          this.gasequipment.updateInterval = 1;
        } else {
          this.gasequipment.updateInterval = 0;
        }
        if (this.Isoxygen == true) {
          this.gasequipment.Isoxygen = 1;
        } else {
          this.gasequipment.Isoxygen = 0;
        }
        if (this.Iscarbondioxide == true) {
          this.gasequipment.Iscarbondioxide = 1;
        } else {
          this.gasequipment.Iscarbondioxide = 0;
        }
        if (this.Isnitrogen == true) {
          this.gasequipment.Isnitrogen = 1;
        } else {
          this.gasequipment.Isnitrogen = 0;
        }
        if (this.Ischlorinehydride == true) {
          this.gasequipment.Ischlorinehydride = 1;
        } else {
          this.gasequipment.Ischlorinehydride = 0;
        }
        if (this.Iscarbonicoxide == true) {
          this.gasequipment.Iscarbonicoxide = 1;
        } else {
          this.gasequipment.Iscarbonicoxide = 0;
        }
        await this.$store.dispatch({
          type: "gasequipment/create",
          data: this.gasequipment,
        });
        (this.$refs.gasequipmentForm as any).resetFields();
        this.$emit("save-success");
        setTimeout(() => {
          this.idisable = false; //点击一次时隔两秒后才能再次点击
        }, 2000);
        this.$emit("input", false);
        this.$emit("Checkbox", false);
        this.gasequipment.Numbler='';
        this.Isoxygen = false;
        this.Iscarbondioxide = false;
        this.Isnitrogen = false;
        this.Ischlorinehydride = false;
        this.Iscarbonicoxide = false;
        this.updateInterval = false;
      }
    });
  }
  cancel() {
    (this.$refs.gasequipmentForm as any).resetFields();
    this.$emit("input", false);
    this.$emit("Radio", false);
    this.$emit("Checkbox", false);
    this.displaynone = "";
    this.selwarehouselist = [];
    this.selfloorlist = [];
  }
  gasequipmentRule = {
    ftId: [
      {
        type: "number",
        required: true,
        message: "请选择库区",
        trigger: "change",
      },
    ],
    wId: [
      {
        type: "number",
        required: true,
        message: "请选择库房",
        trigger: "change",
      },
    ],
    SNID: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [
      {
        type: "number",
        required: true,
        message: "请选择楼层",
        trigger: "change",
      },
    ],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    // number: [{ message: "请填写位置编号", trigger: "blur" }],
    gId: [
      {
        type: "number",
        required: true,
        message: "请选择阈值方案",
        trigger: "change",
      },
    ],
    gas_type: [
      {
        type: "number",
        required: true,
        message: "请选择采集气体类型",
        trigger: "change",
      },
    ],
    acquisitionInterval: [
      {
        type: "number",
        required: true,
        message: "请选择采集间隔",
        trigger: "change",
      },
    ],
  };
}
